export const REGISTRATION_TYPES = {
    "0": "Registrace bez výběru",
    "1": "Zákazník",
    "2": "Obchodní Partner",
    "3": "Dell Technologies Tým ",
    "4": "SWS Tým ",
    "5": "100 Mega",
    "6": "AT Computers",
};